import { Button, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import ComingSoonIllustration from 'assets/illustration_coming_soon';
import { MotionContainer, varBounceIn } from 'components/animate';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';

const ErrorScreen = ({ error }: { error: string }) => {
  return (
    <MotionContainer initial="initial" open sx={{ height: '100%' }}>
      <Stack
        sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}
        alignItems="center"
        height="100%"
        justifyContent="center"
      >
        <motion.div variants={varBounceIn}>
          <Typography variant="h4" paragraph color="error">
            Извините, произошла ошибка!
          </Typography>
        </motion.div>

        <motion.div variants={varBounceIn}>
          <Typography variant="body1" sx={{ color: 'text.secondary', mb: 6 }}>
            Описание ошибки: {error}
          </Typography>
          <ComingSoonIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </motion.div>

        <Button to="/main" size="large" variant="contained" component={RouterLink}>
          Вернуться на главную страницу
        </Button>
      </Stack>
    </MotionContainer>
  );
};

export default ErrorScreen;
